export const AGENCY_JOBS_HISTORY_FETCH_BEGIN = 'syftacp/AGENCY_JOBS_HISTORY_FETCH_BEGIN' as const
export const AGENCY_JOBS_HISTORY_FETCH_SUCCEEDED = 'syftacp/AGENCY_JOBS_HISTORY_FETCH_SUCCEEDED' as const
export const AGENCY_JOBS_HISTORY_FETCH_FAILED = 'syftacp/AGENCY_JOBS_HISTORY_FETCH_FAILED' as const
